// @flow
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { createSimpleAPIMiddleware } from "@localytics/redux-simple-api-middleware/lib/simpleAPI";
import { SIMPLE } from "@localytics/redux-simple-api-middleware/lib/constants";
import * as Types from "./actionTypes";
import LoginReducer from "./reducer";

/* eslint-disable no-unused-vars */
const prefixUrlMiddleware = store => next => action => {
  if (action && action[SIMPLE] !== undefined) {
    const basePath =
      window.location.pathname !== "/"
        ? window.location.pathname.replace("index.html", "").replace(/\/$/, "")
        : "";
    const spaPrefix = endpointPath =>
      action[SIMPLE].endpoint[0] !== "/"
        ? `${basePath}/${endpointPath}`
        : endpointPath;
    const newAction = {
      [SIMPLE]: {
        ...action[SIMPLE],
        endpoint: spaPrefix(action[SIMPLE].endpoint)
      }
    };
    return next(newAction);
  }
  return next(action);
};

/* eslint-disable */
const redirectMiddleware = store => next => action => {
  switch (action.status) {
    case 200:
      if (action.response && action.response.auth_code_url) {
        return next(action);
      } else if (
        action.payload.next &&
        action.payload.next.indexOf("http") === 0
      ) {
        return (window.location = action.payload.next);
      } else if (action.payload.next) {
        return (window.location = `${window.location.protocol}//${window.location.hostname}${
          action.payload.next
          }`);
      } else {
        return (window.location = `${
          window.location.protocol
          }//${window.location.hostname}/`);
      }
    case 401:
      return store.dispatch({ type: Types.INCORRECT_CREDENTIALS_NOTIFICATION });
    case 500:
      return store.dispatch({ type: Types.SERVER_ERROR_NOTIFICATION });
    default:
      return next(action);
  }
};
/* eslint-enable */

function configureBannerFromURLQuery(queryParams) {
  try {
    const loginNotification = (() => {
      const param = new URLSearchParams(queryParams).get("banner");
      switch (param) {
        case "logged-out":
          return Types.LOGGED_OUT_WARNING_NOTIFICATION;
        case "signout-success":
          return Types.SIGNED_OUT_SUCCESSFULLY_NOTIFICATION;
        case "bad-credentials":
          return Types.INCORRECT_CREDENTIALS_NOTIFICATION;
        case "password-expired":
          return Types.PASSWORD_EXPIRED_NOTIFICATION;
        case "reset-email-not-sent":
            return Types.EMAIL_NOT_SENT_NOTIFICATION;  
        case "error":
          return Types.SERVER_ERROR_NOTIFICATION;
        default:
          return Types.NO_NOTIFICATION;
      }
    })();

    return {
      loginNotification
    };
  } catch (e) {
    return {
      loginNotification: Types.NO_NOTIFICATION
    };
  }
}

const configure = () => {
  let middleware = applyMiddleware(
    thunk,
    prefixUrlMiddleware,
    /* eslint-disable no-unused-vars */
    createSimpleAPIMiddleware((request, getState) => ({
      ...request.body
    })),
    redirectMiddleware
  );

  /* eslint-disable no-underscore-dangle */
  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    middleware = compose(middleware, window.__REDUX_DEVTOOLS_EXTENSION__());
  }
  const store = createStore(
    LoginReducer,
    { ...configureBannerFromURLQuery(window.location.search) },
    middleware
  );

  return store;
};

export default configure();
